import React from 'react';
import { SxStyle } from '../../../../types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import svStrings from '../../../../sv-strings';
import Box from '@mui/material/Box';

const steps = [svStrings.polls.stepQuizOne, svStrings.polls.stepQuizTwo];

const styles: SxStyle = {
  container: {
    backgroundColor: '#0e1f4d1a',
  },
  stepper: {
    maxWidth: '400px',
    height: '60px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
};

interface Props {
  activeStep: number;
}

const PollQuizStepper = ({ activeStep }: Props) => {
  return (
    <Box sx={styles.container}>
      <Stepper nonLinear sx={styles.stepper} activeStep={activeStep}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default PollQuizStepper;
